module.exports = __webpack_public_path__ + "static/media/HelvNeue75_Cyr.fa2f6958.ttf";